import { render, staticRenderFns } from "./com-channel.vue?vue&type=template&id=6779079c&scoped=true"
import script from "./com-channel.vue?vue&type=script&lang=js"
export * from "./com-channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779079c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6779079c')) {
      api.createRecord('6779079c', component.options)
    } else {
      api.reload('6779079c', component.options)
    }
    module.hot.accept("./com-channel.vue?vue&type=template&id=6779079c&scoped=true", function () {
      api.rerender('6779079c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-channel.vue"
export default component.exports